import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const EVENT_BUYER_TEAMS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('EVENT_BUYER_TEAMS');
export const EVENT_BUYER_TEAMS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	EVENT_BUYER_TEAMS_CRUD_ACTION_CONSTANTS
);

export const ADD_CONTACT_TO_EVENT_BUYER_TEAM_FORM_DATA = 'ADD_CONTACT_TO_EVENT_BUYER_FORM_DATA';

export const addContactToEventBuyerTeamFormData = (eventBuyerTeam) => ({
	eventBuyerTeam,
	type: ADD_CONTACT_TO_EVENT_BUYER_TEAM_FORM_DATA,
});
